import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { fetchAvailableQuestionNum } from "@/api/question";
let SystemRule = class SystemRule extends Vue {
    constructor() {
        super(...arguments);
        this.ruleListArray = [];
        this.isLoading = false;
    }
    get totalNum() {
        let total = 0;
        this.ruleListArray.forEach((t) => {
            total += Number(t.selectedNum);
        });
        return total;
    }
    get isShowDialog() {
        return this.visible;
    }
    set isShowDialog(_) {
        this.$emit('cancel');
    }
    created() {
        this.getAvailableQuestionNum();
    }
    changeNum(rule) {
        console.log("是否触发");
        if (rule.selectedNum) {
            if (!/^(0|[1-9][0-9]*)$/.test(rule.selectedNum))
                rule.selectedNum = 0;
            if (rule.selectedNum > rule.availableNum) {
                rule.selectedNum = rule.availableNum;
                this.$message.error(`${this.transferType(rule.type)}最多可选${rule.availableNum}道`);
            }
        }
    }
    transferType(type) {
        switch (type) {
            case 0:
                return "单选题";
            case 1:
                return "多选题";
            case 2:
                return "问答题";
            case 3:
                return "判断题";
            case 4:
                return "填空题";
            case 5:
                return "不定项选择题";
            case 6:
                return "材料题";
            default:
                return "未知的题型";
        }
    }
    async getAvailableQuestionNum() {
        this.isLoading = true;
        try {
            const { data } = await fetchAvailableQuestionNum({
                categoryIds: this.selectedQuestionClassIds.join(','),
                questionIds: this.selectedQuestionsIds.join(',')
            });
            const list = data.data.questionNumList;
            list.forEach((t) => {
                var n = {
                    type: t.type,
                    availableNum: t.total,
                    selectedNum: 0,
                    sort: Number(t.type)
                };
                this.ruleListArray.push(n);
            });
            this.ruleListArray.sort((a, b) => a.sort - b.sort);
            console.log(this.ruleListArray, "系统抽题的规则");
        }
        catch (_) { }
        finally {
            this.isLoading = false;
        }
    }
    backToSelectClassify() {
        this.$emit("back-to-select-classify");
    }
    confirm() {
        if (this.ruleListArray.length != 0) {
            this.ruleListArray.forEach((e) => {
                e.selectedNum || (e.selectedNum = 0);
            });
            if (this.totalNum > 1000) {
                this.$message.error("题目超过上限1000道");
            }
            else {
                this.$emit("system-confirm", { ruleList: this.ruleListArray });
            }
        }
        else {
            this.$message.error("当前所选题目分类下无可选题目");
        }
    }
};
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], SystemRule.prototype, "selectedQuestionClassIds", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], SystemRule.prototype, "selectedQuestionsIds", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SystemRule.prototype, "visible", void 0);
SystemRule = tslib_1.__decorate([
    Component({
        name: 'SystemRule',
    })
], SystemRule);
export default SystemRule;
